import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import "../jobsV2.scss";
import "./candidateList.scss";
import useCandidateAccess from "../../../utils/useCandidateAccess";
import { CANDIDATE_VIEWS } from "./constants";
import CandidateViewTabs from "./CandidateViewTabs";
import CandidateWiseView from "./CandidateWise/CandidateWiseView";
import ActivityWiseView from "./ActivityWise/ActivityWiseView";

const VIEW_PARAM = "view";

// Job → Candidates page. "Candidate-wise" is the original one-row-per-candidate table;
// "Activity-wise" lists one row per candidate stage. The active tab lives in ?view= so
// it survives a refresh.
const CandidatesV2 = () => {
  const { jobId } = useParams();
  const access = useCandidateAccess(jobId);
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get(VIEW_PARAM) === CANDIDATE_VIEWS.ACTIVITY ? CANDIDATE_VIEWS.ACTIVITY : CANDIDATE_VIEWS.CANDIDATE;

  const changeView = (next) => {
    const params = new URLSearchParams(searchParams);
    if (next === CANDIDATE_VIEWS.ACTIVITY) params.set(VIEW_PARAM, next);
    else params.delete(VIEW_PARAM);
    setSearchParams(params, { replace: true });
  };

  return (
    <div className="candidate-list-page">
      <CandidateViewTabs value={view} onChange={changeView} />
      <CandidateWiseView access={access} hidden={view !== CANDIDATE_VIEWS.CANDIDATE} />
      {view === CANDIDATE_VIEWS.ACTIVITY && <ActivityWiseView jobId={jobId} access={access} />}
    </div>
  );
};

export default CandidatesV2;
